import React, { useState, useEffect } from "react";
import Joyride, { STATUS } from "react-joyride";
import { Button } from "appStyles";
import { withRedux } from "helpers";
import HelpIcon from "@material-ui/icons/Help";

const ruleSets = {
  home: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          Welcome! Start by downloading your app on the Mobile360 marketplace.
          Head to this link on your mobile device.
        </h3>
      ),
      target: ".appLink",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "auto",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          We kickstarted your app with some of the most popular pages! Check out
          the “Current Pages” section below. Click on any page to edit it.
        </h3>
      ),
      target: ".currentPages",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "auto",
      isFixed: true,
    },
    //

    {
      content: (
        <h3 style={{ color: "white" }}>
          Super important! In order for your app to go live on the Mobile360
          marketplace, you must hit the Publish button.
        </h3>
      ),
      target: ".reqToPublish",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "auto",
    },
  ],
  deals: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          Smart move! Keep your customers coming back by offering exclusive
          offers. Here are some basics of how deals work:
        </h3>
      ),
      target: ".heading",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
    },
    {
      content: <h3>Start off by adding your first deal.</h3>,
      target: ".newDealButton",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "bottom",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          Redemption Type! This gives you flexibility on how you’d like your
          customers to redeem deals.
        </h3>
      ),
      target: ".dealPassword",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "top",
    },
  ],

  businessCreation: [
    // CHECK
    {
      content: (
        <h3 style={{ color: "white" }}>
          Welcome! To get started, tell us a little about your business. We'll
          take your info and turn it into the first page of your app!{" "}
        </h3>
      ),
      target: ".heading",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "top",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          Watch a live preview of what your app will look like as you type in
          your information. Remember, all phones are different, so the actual
          look will slightly differ from what you see here.
        </h3>
      ),
      target: ".appView",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "left",
    },
    // {
    //   content: (
    //     <h3 style={{ color: "white" }}>
    //       In order to customize this page, click on the various components of
    //       the phone screen. An editor will pop up on the left. Be sure to hit
    //       save after!
    //     </h3>
    //   ),
    //   target: ".appView",
    //   disableBeacon: true,
    //   locale: {
    //     next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
    //     back: <span style={{ color: "white" }}>Previous</span>,
    //     last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
    //   },
    //   placement: "left",
    // },
  ],

  punchCard: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          In order to customize this page, click on the various components of
          the phone screen. An editor will pop up on the left. Be sure to hit
          save after!
        </h3>
      ),
      target: ".appView",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "left",
    },
  ],
  titleText: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          In order to customize this page, click on the various components of
          the phone screen. An editor will pop up on the left. Be sure to hit
          save after!
        </h3>
      ),
      target: ".appView",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "left",
    },
  ],
  imageTitleText: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          In order to customize this page, click on the various components of
          the phone screen. An editor will pop up on the left. Be sure to hit
          save after!
        </h3>
      ),
      target: ".css-tfzyfe",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "left",
    },
  ],
  pictureCatalog: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          In order to customize this page, click on the various components of
          the phone screen. An editor will pop up on the left. Be sure to hit
          save after!
        </h3>
      ),
      target: ".css-tfzyfe",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "left",
    },
  ],
  website: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          In order to customize this page, click on the various components of
          the phone screen. An editor will pop up on the left. Be sure to hit
          save after!
        </h3>
      ),
      target: ".css-tfzyfe",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "left",
    },
  ],
  rewards: [
    {
      content: (
        <h3 style={{ color: "white" }}>
          Great! A loyalty system means loyal customers. You'll keep them coming
          back for more. Here are some basics of how rewards work:
        </h3>
      ),
      target: ".heading",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "top",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          A customer earns points for every dollar they spend. You can define
          that here.{" "}
        </h3>
      ),
      target: ".pointsConversion",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "top",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          Optionally, a customer can receive cash credit for future purchases as
          well. You can define how much they need to spend to get $1 cash credit
          here. Uncheck the box to turn this option off.
        </h3>
      ),
      target: ".cashCredit",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "top",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          Customers can use points to redeem items as you define them. Just hit
          click here to add your first reward. This is optional. If you just
          want to use rewards for cash credit, that's fine too!
        </h3>
      ),
      target: ".addRewardButton",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "top",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          Redemption Type! This gives you flexibility on how you’d like your
          customers to redeem reward items.
        </h3>
      ),
      target: ".rewardPassword",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
      },
      placement: "top",
    },
    {
      content: (
        <h3 style={{ color: "white" }}>
          Give it a go! Set your redemption type to "None" and head to the
          Mobile360 app to test out how it works.
        </h3>
      ),
      target: ".heading",
      disableBeacon: true,
      locale: {
        next: <span style={{ color: "rgb(137, 210, 211)" }}>Next</span>,
        back: <span style={{ color: "white" }}>Previous</span>,
        last: <span style={{ color: "rgb(137, 210, 211)" }}>Finish</span>,
      },
      placement: "top",
    },
  ],
};

function JoyRide(props) {
  const {
    activeTemplate: { pageName },
    activeTemplate,
    platformInfo,
  } = props;
  const [shouldRun, setRun] = useState(false);
  const isAtApplication = window.location.pathname === "/application";
  // console.log("isAtApplication: " + isAtApplication);
  const isAtBusinessForm = window.location.pathname === "/form/business";
  const hasView = platformInfo.display.view;
  // hide the get help button if no rule is set
  const currentPage = () => {
    if (isAtBusinessForm) return "businessCreation";

    if (!isAtApplication || hasView) return null;

    if (!activeTemplate) {
      return "home";
    } else {
      return activeTemplate.type;
    }
  };

  // console.log(currentPage());
  // console.log("shouldRun: " + shouldRun);

  const updateOn = `${currentPage()}-${window.location.pathname}`;

  useEffect(() => {
    const toured = localStorage.getItem(`${currentPage()}-toured`);
    setRun(!JSON.parse(toured));
  }, [updateOn]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      setTouredCache();
    }
  };

  const setTouredCache = () => {
    localStorage.setItem(`${currentPage()}-toured`, true);
  };

  const currentRuleSet = ruleSets[currentPage()];
  // console.dir(currentRuleSet);

  if (!currentRuleSet) return null;
  // if (isAtApplication && currentPage() == "home") return null;

  return (
    <div>
      {currentPage() != "home" && (
        <Button
          onClick={() => setRun(true)}
          style={{
            fontSize: "14px",
            alignItems: "center",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
          className="helper"
        >
          <HelpIcon style={{ marginRight: "5px" }} /> Get Help!
        </Button>
      )}
      <Joyride
        callback={handleJoyrideCallback}
        continuous={true}
        run={shouldRun}
        showSkipButton={true}
        disableScrolling={false}
        scrollToFirstStep={true}
        steps={ruleSets[currentPage()]}
        styles={{
          options: {
            arrowColor: "#89d2d3",
            backgroundColor: "#89d2d3",
            primaryColor: "white",
            textColor: "white",
            width: 500,
            height: 400,
            zIndex: 1000,
            overlayHeight: `100vh`,
          },
          overlay: {
            backgroundColor: "none",
            mixBlendMode: "unset",
            height: "100%",
          },
          spotlight: {
            backgroundColor: "none",
          },
        }}
      />
    </div>
  );
}

export default withRedux(JoyRide);
